export default function setZipErrAction( zipError) {
    return {
        type: 'SET_ZIP_ERR',
        payload: zipError
    }
}